import React from 'react';
import { Tile, PrimaryButton, Columns, CompactSelect, Column, FormInput, Option } from 'lqx-react';
import { Identifier, IdentifierType } from 'api';
import { Flex } from 'lqx-react/src';
import { Collection } from '@type-r/models';
import { useLinked } from '@type-r/react';
import { makeStyles } from '@material-ui/core';

export const removeIdentifier = (list) => (i) => {
    list.remove(i);
};

const addIdentifier = (value, type, identifiers) => {
    const newI = new Identifier();
    newI.value = value;
    newI.key = type;
    identifiers.add(newI);
};

const identifierTextMapping = {
    BankAccount : 'Bank Account',
    ExternalRelationshipId : 'External Relationship Number',
    NameAlias : 'Name Alias',
    EmailDomain : 'Domain',
    ISA : 'ISA',
    GSId : 'GSId',
};

export const AddIdentifier = ({ identifiers, identifierTypes }:
                                    {identifiers: Collection<Identifier>, identifierTypes: IdentifierType[] }) => {
    const $type = useLinked<string>( null );
    const $value = useLinked<string>( null );
    return (<Columns>
        <Column>
            <CompactSelect label="Identifier Type" $value={ $type }>
                {
                    identifierTypes.map(option => <Option key={option} value={ option }> { identifierTextMapping[option] || option} </Option>)
                }
            </CompactSelect>
        </Column>
        <Column>
        <FormInput label="Value" $value={$value} />
        </Column>
        <Column>
        <PrimaryButton onClick = { () => addIdentifier($value.value, $type.value, identifiers)}>Add Identifier</PrimaryButton>
        </Column>
    </Columns>);
};

export const IdentifiersRow = (showShared, remove) => ({ data, style, index }) => {
    const identifier: Identifier = data.items[index];
    let styles = useStyles();
    return (
        <Tile
            large={false}
            style={style}
            color={showShared && !identifier.shared ? 'red' : 'green'}
            title={identifier.key}
            aboveTitle={identifier.value}
            extra={
                <>
                    <Flex grow />
                    <PrimaryButton className={styles.primaryButton}
                        onClick={() => remove(identifier)}
                    >Remove</PrimaryButton>
                </>
            }
        >
        </Tile>
    );
};

const useStyles = makeStyles({
    primaryButton: {
        backgroundColor: 'red'
    }
});